module.exports = {
      id: "filter-usage",
      viewBox: "0 0 8 8",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#filter",
      toString: function () {
        return this.url;
      }
    }